import axios from 'axios';

export type CreatePresentationParams = {
	customerEmail: string;
	contactId: string;
	dealId: string;
	designIds: Array<string>;
	dealerNote: string;
	expiresAt: string;
	getAccessTokenSilently: () => Promise<string>;
};

export type CreatePresentationResult = {
	presentationId: string;
	link: string;
};

export const createPresentation = async (params: CreatePresentationParams): Promise<[CreatePresentationResult | null, string | null]> => {
	const { customerEmail, contactId, dealId, designIds, dealerNote, expiresAt, getAccessTokenSilently } = params;

	try {
		const token = await getAccessTokenSilently();
		const apiUrl = import.meta.env.VITE_API_URL;
		const response = await axios.post<CreatePresentationResult>(
			`${apiUrl}/presentations`,
			{ customerEmail, contactId, dealId, designIds, dealerNote, expiresAt },
			{ headers: { Authorization: `Bearer ${token}` } }
		);
		return [response.data, null];
	} catch {
		return [null, 'Failed to create presentation'];
	}
};
